import "./About.module.css";
import Header from "@/reusable_sections/Header";
import ConferenceOverview from "./sections/ConferenceOverview";
import OrganizingTeam from "./sections/OrganizingTeam";
import ConferenceLeads from "./sections/ConferenceLeads";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <ConferenceOverview />
      <ConferenceLeads />
      <OrganizingTeam />
      <Footer />
    </div>;
}